import { ConfigStore } from "../../store/modules/config";
import { PersonStore } from "../../store/modules/person";
import { ContractsStore } from "../../store/modules/contracts";
import { Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import IOperationService from "../../services/operations/IOperationService";
import { OperationRequestData } from "../../data/operationRequestData";
import { OperationsApi } from "../../services/api/OperationsApi";
import { container } from "@/inversify.config";
import { DiTokens } from "../../services/diTokens";
import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import Vue from "vue";

/**
 *  Класс для компоненты контроллера модального окна СБП заявок на перевод.
 */
export class ServerCommandsControllerVue extends Vue {

  /** отслеживаем закрытие модального окна и подписываемся заного */
  @Watch('commandsModal', { immediate: true })
  modalToggle(val: boolean) {
    if (val === false && this.commandsProps) {
      this.commandsProps = null;
      this.subscribeServerCommands();
    }
  }

  /** отслеживаем респондент код и узнаем когда загрузился апистейт */
  @Watch('respondentCode', { immediate: true })
  async apiStateLoaded(val: string) {
    if (val) {
      await this.subscribeServerCommands();
    }
  }

  /** флаг модального окна */
  commandsModal: boolean = false;

  /** параметры для модального окна */
  commandsProps: any = null;

  /**
 * Сервис операций
 * @returns {IOperationService}
 */
  get service(): IOperationService {
    return container.get<IOperationService>(DiTokens.ServerCommandsService);
  }

  /**
 * Код операции.
 * @returns {string} - код для отправки в апи.
 */
  get respondentCode(): string {
    return this.configStore.apiData.OperationCodeOfGetServerCommands;
  }

  /**
 * Хранилище конфигураций
 * @returns {ConfigStore}
 */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**
 * Хранилище данных пользователя
 * @returns {PersonStore}
 */
  get personStore(): PersonStore {
    return getModule(PersonStore, this.$store);
  }

  /**
 * Хранилище счетов
 * @returns {ContractsStore}
 */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  /** Получение комманд с сервера */
  async getServerCommands(): Promise<OperationRequestData> {
    if (!this.personStore.personInfo.Data.DefaultOutAccount || !this.contractsStore.contracts.Contracts?.length)
      return null;
    let ord: OperationRequestData = new OperationRequestData();
    ord.respondentCode = this.respondentCode;
    ord.setProperty("take", '1', DeclarationPropertiesTypes.String);
    ord = await OperationsApi.executeOperationSendAsync(ord);
    return ord;
  }

  /** Подписка на получение комманд с сервера */
  async subscribeServerCommands() {
    let ord: OperationRequestData = await this.getServerCommands();
    if (ord && ord.listObjects[0] && ord.listObjects[0].Properties) {
      this.commandsModal = true;
      this.commandsProps = ord.listObjects[0].Properties;
    } else {
      setTimeout(() => {
        this.subscribeServerCommands();
      }, 10000)
    }
  }

  async init() {
    // await this.subscribeServerCommands();
  }

}
